/**
 * Locale-aware date formatting. Pass the active i18n language (e.g.
 * `useTranslation().i18n.language`) so dates follow the user's chosen locale
 * instead of a hardcoded 'en-GB'.
 */

/** Short date, e.g. "5 Jun" / "5 июн." */
export function formatShortDate(value: string | number | Date, locale: string): string {
  return new Date(value).toLocaleDateString(locale || 'en', { day: 'numeric', month: 'short' });
}

/** Long date for the Home greeting, e.g. "Mon, 5 June" / "пн, 5 июня". */
export function formatLongDate(value: string | number | Date, locale: string): string {
  return new Date(value).toLocaleDateString(locale || 'en', {
    weekday: 'short',
    day: 'numeric',
    month: 'long',
  });
}

/**
 * Birth date `YYYY-MM-DD` with the year, e.g. "1 May 2019" / "1 мая 2019" / "1 травня 2019".
 * Parsed as a LOCAL calendar date, so the day never shifts with the timezone. The trailing year
 * suffix some locales add (« г.» / « р.») is dropped. An invalid string is returned unchanged.
 */
export function formatBirthDate(isoDate: string, locale: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(isoDate);
  if (!m) return isoDate;
  const [y, mo, d] = [Number(m[1]), Number(m[2]), Number(m[3])];
  const date = new Date(y, mo - 1, d);
  if (date.getFullYear() !== y || date.getMonth() !== mo - 1 || date.getDate() !== d) return isoDate;
  // Plain 'en' would give "May 1, 2019"; en-GB keeps the day-month-year order of ru/uk.
  const tag = !locale || locale === 'en' ? 'en-GB' : locale;
  return date
    .toLocaleDateString(tag, { day: 'numeric', month: 'long', year: 'numeric' })
    .replace(/[\s  ]*(г|р)\.$/, '');
}
